class CartUpsellForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.submitButton = this.form?.querySelector('[type="submit"]');

    if (!this.form || !this.submitButton) {
      return;
    }

    this.form.addEventListener('submit', this.#onSubmit.bind(this));
  }

  #onSubmit(evt) {
    evt.preventDefault();

    const idInput = this.form.querySelector('[name="id"]');

    if (!idInput?.value || this.submitButton.getAttribute('aria-disabled') === 'true') {
      return;
    }

    const spinner = this.submitButton.querySelector('.loading-overlay__spinner');
    const cartDrawer = document.querySelector('cart-drawer');
    const drawerWasOpen = Boolean(cartDrawer?.classList.contains('active'));
    const cartPath = window.routes?.cart_url || '/cart';
    const onCartPage =
      window.location.pathname === cartPath || window.location.pathname.startsWith(`${cartPath}/`);

    this.submitButton.setAttribute('aria-disabled', 'true');

    if (spinner) {
      spinner.classList.remove('hidden');
    }

    const formData = new FormData(this.form);
    formData.append('sections', 'cart-drawer,header,main-cart');
    formData.append('sections_url', window.location.pathname);

    fetch(`${window.routes.cart_add_url}`, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
      },
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Network response was not ok: ${response.status}`);
        }

        return response.json();
      })
      .then((response) => {
        if (response.status) {
          console.error(response.description);
          return;
        }

        this.#applySections(response);

        if (cartDrawer && !drawerWasOpen && !onCartPage) {
          cartDrawer.open(this.submitButton);
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.submitButton.removeAttribute('aria-disabled');

        if (spinner) {
          spinner.classList.add('hidden');
        }
      });
  }

  #applySections(response) {
    if (!response.sections) {
      return;
    }

    if (response.sections['cart-drawer']) {
      const doc = new DOMParser().parseFromString(response.sections['cart-drawer'], 'text/html');
      const target = document.querySelector('#CartDrawer-Content');
      const source = doc.querySelector('#CartDrawer-Content');

      if (target && source) {
        target.replaceWith(source);
      }
    }

    if (response.sections['header']) {
      replaceCartIconBubbleFromHeaderSection(response.sections['header']);
    }

    if (response.sections['main-cart']) {
      const doc = new DOMParser().parseFromString(response.sections['main-cart'], 'text/html');
      const target = document.querySelector('.shopify-section.section-cart');
      const source = doc.querySelector('.shopify-section.section-cart');

      if (target && source) {
        target.replaceWith(source);
      }
    }
  }
}

if (!customElements.get('cart-upsell-form')) {
  customElements.define('cart-upsell-form', CartUpsellForm);
}
